import type Moengage from "@moengage/web-sdk";
import { GenericObject } from "@taager/reinforcements";
import { environment } from "environment";
import user from "user";

const moengageConfig = {
  app_id: environment.MOENGAGE_APP_ID,
  cluster: environment.MOENGAGE_DATA_CENTER,
  debug_logs: environment.MOENGAGE_DEBUG_LOGS,
};

export class MoEngageManagerService {
  private moengageInstance: typeof Moengage | null = null;

  private async getInstance() {
    if (!this.moengageInstance) {
      const module = await import("@moengage/web-sdk");
      this.moengageInstance = module.default;
      if (user.isLoggedIn) {
        this.moengageInstance.initialize(moengageConfig);
      }
    }

    return this.moengageInstance;
  }

  public async identify() {
    const instance = await this.getInstance();
    instance.add_unique_user_id(user.id);
    instance.add_first_name(user.fullName);
    instance.add_email(user.email);
    instance.add_mobile(user.phoneNumber);
  }

  public async destroySession() {
    const instance = await this.getInstance();
    instance.destroy_session();
  }

  public async trackEvent(eventName: string, data?: GenericObject) {
    const instance = await this.getInstance();
    instance.track_event(eventName, data);
  }
}

export const moengageService = new MoEngageManagerService();
